/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/assistant.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * What the person was looking at when the conversation started.   - ASSISTANT_CONTEXT_TYPE_NONE: Started from nowhere in particular — the command palette on a general screen.
 */

export const TrackerAssistantContextType = {
  AssistantContextTypeUnspecified: 'ASSISTANT_CONTEXT_TYPE_UNSPECIFIED',
  AssistantContextTypeIssue: 'ASSISTANT_CONTEXT_TYPE_ISSUE',
  AssistantContextTypeProject: 'ASSISTANT_CONTEXT_TYPE_PROJECT',
  AssistantContextTypePage: 'ASSISTANT_CONTEXT_TYPE_PAGE',
  AssistantContextTypeNone: 'ASSISTANT_CONTEXT_TYPE_NONE',
} as const

export type TrackerAssistantContextType =
  (typeof TrackerAssistantContextType)[keyof typeof TrackerAssistantContextType]
